import {useDispatch} from "react-redux";
import {sermonActions} from "../store";

const SermonSearch = () => {
    const dispatch = useDispatch();
    const keyHandler = (evt) => {
        dispatch(sermonActions.filterSermons(evt.target.value));
    };
    return (
        <div className="row mb-3">
            <div className="col">
                <input type="text" className="form-control" placeholder="Search for Sermon" onKeyUp={keyHandler}/>
            </div>
        </div>
    )
}
export default SermonSearch;